import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=01a8ac88&scoped=true"
import script from "./order-status.vue?vue&type=script&lang=js"
export * from "./order-status.vue?vue&type=script&lang=js"
import style0 from "./order-status.vue?vue&type=style&index=0&id=01a8ac88&prod&lang=scss&scoped=true"
import style1 from "./order-status.vue?vue&type=style&index=1&id=01a8ac88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8ac88",
  null
  
)

export default component.exports